<template>
	<div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">
		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else class="row justify-content-center">
            <div class="col-md-6 mb-5">
                <alert-success :form="form" :class="'shadow-sm'" message="Your changes have been saved!"></alert-success>

                <h3 class="tx-color-01">Investment Management Agreement</h3>
                <form class="row" @submit.prevent="save">
					<div class="col-12">
						<div class="custom-control custom-checkbox">
							<input v-model="form.hasAgreed" type="checkbox" class="custom-control-input shadow-sm" id="agree">
							<label class="custom-control-label tx-color-03 mg-b-30" for="agree">
								By checking the box, I hereby declare that I have read and understood the <a href="/storage/documents/IC-Asset-Managers_Retail-Investment-Management-Agreement.pdf" target="_blank">Investment Management Agreement</a> and that I
								hereby agree to it. I declare that all information provided is true, accurate and correct as at today. 
								I instruct IC Asset Managers (Ghana) LTD and IC Securities (Ghana) LTD to act based on this information, unless
								otherwise notified in writing by me. I authorise IC Asset Managers (Ghana) LTD and IC Securities (Ghana) LTD to act
								on instructions relating to my account(s) received from the Authorised Signatory(ies).
							</label>
						</div>
					</div>
                    <div class="col-12 border-top mt-3">
                        <button-component :busy="form.busy" :label="'Save'" :label-loading="'Saving changes...'" :button-class="'btn btn-default float-right mt-3 shadow-sm'"></button-component>
                    </div>
                </form>
            </div>
        </div>
	</div>
</template>

<style scoped>
	.custom-checkbox .custom-control-label::before,
	.custom-checkbox .custom-control-label::after {
		top: 8% !important;
	}
</style>

<script>
	import store from "../../../../store";

	export default {
		data() {
			return {
				error: null,
				form: new Form({
					hasAgreed: null
				})
			};
		},
		beforeRouteEnter(to, from, next) {
			axios
				.get(
					`/api/companies/${store.getters.company.external_client_id}`,
					{
						params: {
							type: "investment_management_agreement"
						}
					}
				)
				.then(response => {
					const agreement =
						response.data.data.investment_management_agreement;

					if (!_.isEmpty(agreement)) {
						next(vm => vm.setData(null, agreement));
					}
				})
				.catch(error => {
					next(vm => vm.setData(error, null));
				});
		},
		watch: {},
		methods: {
			setData(err, agreement) {
				if (err) {
					this.error = err.toString();
				} else {
					this.form.hasAgreed = agreement.hasAgreed;
				}
			},
			save() {
				this.form.patch(
					`/api/companies/${store.getters.company.external_client_id}`,
					{
						params: {
							type: "investment_management_agreement"
						}
					}
				);
			}
		}
	};
</script>
